import { SUPPORTED_LOCALES, LOCALE_DISPLAY_NAMES, type Locale } from '@arthelper/shared';

interface LanguageSelectorProps {
  value: Locale;
  onChange: (locale: Locale) => void;
  variant?: 'default' | 'minimal';
}

const VARIANT_CLASSES = {
  default:
    'rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-900 hover:border-gray-300 focus:border-gray-400 focus:outline-none',
  minimal:
    'w-full text-sm bg-transparent border-none cursor-pointer text-gray-600 hover:text-gray-900 focus:outline-none',
};

export function LanguageSelector({ value, onChange, variant = 'default' }: LanguageSelectorProps) {
  return (
    <select value={value} onChange={(e) => onChange(e.target.value as Locale)} className={VARIANT_CLASSES[variant]}>
      {SUPPORTED_LOCALES.map((locale) => (
        <option key={locale} value={locale}>
          {LOCALE_DISPLAY_NAMES[locale]}
        </option>
      ))}
    </select>
  );
}
